import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { useTranslation } from '@ibk/shared-translation';
import { AppDomain, FeatureFlagUseCase } from '@ibk/shared-types';
import { Loading } from '@ibk/shared-ui';
import { useBenefitContract } from '../../hooks';
import { useContractStatusTracking } from '../../hooks/useContractStatusTracking';
import { HomePage, InsideSalesBenefitsLanding, LandingPageClient } from '../../pages';
import { ContractStatusPage } from '../../pages/ContractStatusPage';
import { HomePageEmissor } from '../../pages/HomePageEmissor';
import { LandingPageAccounting } from '../../pages/LandingPageAccounting';
import { WaitingApprovalPage } from '../../pages/WaitingApprovalPage';
import { ContractStatus } from '../../types';
import { EmissorContractStatus } from '../../types/contractStatus';
function isEvidenceForceEmissorHome() {
    if (globalThis.window === undefined) {
        return false;
    }
    return Boolean(globalThis.__EVIDENCE_FORCE_EMISSOR_HOME__);
}
function renderEmissorContractPage(emissorStatus, appDomain) {
    if (emissorStatus === EmissorContractStatus.REQUESTED || emissorStatus === EmissorContractStatus.CREATED) {
        return _jsx(WaitingApprovalPage, { appDomain: appDomain });
    }
    if (emissorStatus === EmissorContractStatus.ACTIVATED) {
        return _jsx(HomePageEmissor, {});
    }
    return null;
}
export const BenefitsRouter = ({ appDomain, heroImage, onContract, onInviteClients, }) => {
    const { t } = useTranslation();
    const { contractData, contractStatus, isLoading } = useBenefitContract();
    const { isFeatureFlagWhiteListed, isLoading: isLoadingFeatureFlags } = useFeatureFlag(undefined, {
        isLoggedIn: true,
    });
    const isEmissorEnabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.BENEFICIOS_EMISSOR_ENABLED);
    const { status: emissorStatus, isLoading: isLoadingEmissorStatus } = useContractStatusTracking({
        appDomain,
        skip: !isEmissorEnabled,
        redirectOnActive: false,
    });
    if (isEvidenceForceEmissorHome()) {
        return _jsx(HomePageEmissor, {});
    }
    if (isLoading || (isEmissorEnabled && isLoadingEmissorStatus)) {
        return _jsx(Loading, { fullScreen: true, message: t('benefits.loading') });
    }
    if (isEmissorEnabled) {
        const emissorPage = renderEmissorContractPage(emissorStatus, appDomain);
        if (emissorPage) {
            return emissorPage;
        }
    }
    const shouldShowStatusPage = contractData &&
        contractStatus &&
        [
            ContractStatus.CREATED,
            ContractStatus.SYNC_CONTRACT_DATA,
            ContractStatus.PENDING,
            ContractStatus.SYNC_BENEFICIARIES_PARTNER,
        ].includes(contractStatus);
    if (shouldShowStatusPage) {
        return _jsx(ContractStatusPage, { heroImage: heroImage });
    }
    if (contractData && contractData.status === ContractStatus.ACTIVE) {
        return _jsx(HomePage, { contractData: contractData, appDomain: appDomain });
    }
    if (isLoadingFeatureFlags) {
        return _jsx(Loading, { fullScreen: true, message: t('benefits.loading') });
    }
    const isInsideSalesLpEnabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.BENEFICIOS_ENABLE_LP_INSIDE_SALES);
    const insideSalesLanding = (_jsx(InsideSalesBenefitsLanding, { appDomain: appDomain, onContract: onContract, onInviteClients: appDomain === AppDomain.ESCRITORIO ? onInviteClients : undefined, isEmissorFlow: isEmissorEnabled }));
    if (isEmissorEnabled || isInsideSalesLpEnabled) {
        return insideSalesLanding;
    }
    return appDomain === AppDomain.ESCRITORIO ? (_jsx(LandingPageAccounting, { onContract: onContract, onInviteClients: onInviteClients })) : (_jsx(LandingPageClient, { onContract: onContract }));
};
